import React, { useCallback, useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { STATUS, ShipmentLocked } from "@/utils/enum";
import { Validator } from "@/utils/validator";
import { toggleShipmentLock } from "@/services/shipments_new";

export default function PendingModal({ open, onCancel, shipmentId, shipmentLockedStatus, onSuccess, type }) {
  const [formRef] = Form.useForm();
  const [status, setStatus] = useState(STATUS.IDLE);

  const handleFinish = useCallback(
    ({ reason }) => {
      setStatus(STATUS.LOADING);

      const getLockedStatus = () => {
        if (type === "pending") {
          return shipmentLockedStatus === ShipmentLocked.Pending ? null : ShipmentLocked.Pending;
        }

        return shipmentLockedStatus === ShipmentLocked.OnHold ? null : ShipmentLocked.OnHold;
      };

      const getErrorMessage = () => {
        if (type === "pending") {
          return shipmentLockedStatus === ShipmentLocked.Pending
            ? "Failed to release pending"
            : "Failed to set pending";
        }

        return shipmentLockedStatus === ShipmentLocked.OnHold ? "Failed to release hold" : "Failed to set hold";
      };

      const payload = {
        reason,
        locked: getLockedStatus(),
      };

      toggleShipmentLock(shipmentId, payload)
        .then(() => {
          setStatus(STATUS.SUCCESS);
          formRef.resetFields();
          onSuccess?.();
        })
        .catch(() => {
          setStatus(STATUS.ERROR);
          message.error(getErrorMessage());
        });
    },
    [shipmentId, shipmentLockedStatus, onSuccess, formRef, type],
  );

  const handleCancel = useCallback(() => {
    formRef.resetFields();
    onCancel();
  }, [formRef, onCancel]);

  const getTitle = useCallback(() => {
    if (type === "pending") {
      return shipmentLockedStatus === ShipmentLocked.Pending ? "Release Pending" : "Set Pending";
    }

    return shipmentLockedStatus === ShipmentLocked.OnHold ? "Release Hold" : "Set Hold";
  }, [type, shipmentLockedStatus]);

  return (
    <Modal
      title={getTitle()}
      open={open}
      onCancel={handleCancel}
      onOk={formRef.submit}
      confirmLoading={status === STATUS.LOADING}
    >
      <Form form={formRef} layout="vertical" onFinish={handleFinish}>
        <Form.Item label="Reason" name="reason" rules={[Validator.required("Please enter a reason")]}>
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
